import { useTranslation } from 'react-i18next';

interface PriorityBadgeProps {
  score: number;
}

type Priority = 'HIGH' | 'MEDIUM' | 'NORMAL';

function getPriority(score: number): Priority {
  if (score >= 3) return 'HIGH';
  if (score >= 1.5) return 'MEDIUM';
  return 'NORMAL';
}

const PRIORITY_STYLES: Record<Priority, string> = {
  HIGH: 'bg-danger/10 text-danger border border-danger/20',
  MEDIUM: 'bg-copper-soft text-copper-deep border border-copper/20',
  NORMAL: 'bg-slate-100 text-slate-600 border border-hairline',
};

export function PriorityBadge({ score }: PriorityBadgeProps) {
  const { t } = useTranslation();
  const priority = getPriority(score);

  return (
    <span
      className={[
        'text-xs font-semibold px-2 py-0.5 rounded-sm',
        PRIORITY_STYLES[priority],
      ].join(' ')}
    >
      {t(`approver.priority.${priority}`)}
    </span>
  );
}
